/**
 * Build-time feature flags read from REACT_APP_FEATURE_* env vars.
 *
 * CRA inlines env vars at build time, so changing a flag requires a rebuild.
 * Each var must be referenced literally (`process.env.REACT_APP_X`) — dynamic
 * lookups like `process.env[name]` are not replaced and resolve to undefined.
 *
 * Flags only hide UI; the code still ships and the API is unaffected.
 */

export const parseFlag = (value: string | undefined, fallback: boolean): boolean => {
  if (value === undefined || value.trim() === '') return fallback
  return value.trim().toLowerCase() === 'true'
}

const FEATURES = {
  // Public markets (Alpaca) — unreleased, hidden unless explicitly enabled.
  trading: parseFlag(process.env.REACT_APP_FEATURE_TRADING, false),
  publicWallet: parseFlag(process.env.REACT_APP_FEATURE_PUBLIC_WALLET, false),
  // Experimental: trade through a chat assistant (flag name: chat-public-trading).
  chatPublicTrading: parseFlag(process.env.REACT_APP_FEATURE_CHAT_PUBLIC_TRADING, false),
}

export type FeatureName = keyof typeof FEATURES

export const isFeatureEnabled = (feature: FeatureName): boolean => FEATURES[feature]
